module.exports = __webpack_public_path__ + "static/img/model2-7.28526e56.jpg";